import StudentForm from '../pages/StudentForm';
import Application from '../pages/Application';
import Login from '../pages/Login';
import SingleApplicationView from '../components/application/SingleApplicationView';
import PaymentPage from '../pages/PaymentPage';
import PaymentResponsePage from '../components/payment/PaymentResponsePage';
import ThankYouPage from '../components/payment/ThankYouPage';
import PaymentFailedPage from '../components/payment/PaymentFailedPage';
import PaymentPendingPage from '../components/payment/PaymentPendingPage';
import State from '../pages/State';
import District from '../pages/District';
import Institution from '../pages/Institution';
import AdminLogs from '../pages/AdminLogs';

const routes = [
  // PUBLIC ROUTES (NO LOGIN REQUIRED)
  {
    path: '/',
    element: <StudentForm />,
  },
  {
    path: '/payment',
    element: <PaymentPage />,
  },
  {
    path: '/payment-response',
    element: <PaymentResponsePage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '/payment-failed',
    element: <PaymentFailedPage />,
  },
  {
    path: '/payment-pending',
    element: <PaymentPendingPage />,
  },

  // ADMIN LOGIN (ONLY FOR ADMINS)
  {
    path: '/login',
    element: <Login />,
  },

  // ADMIN PROTECTED ROUTES (LOGIN REQUIRED)
  {
    path: '/applications',
    element: <Application />,
    requiresAuth: true,
  },
  {
    path: '/application/:id',
    element: <SingleApplicationView />,
    requiresAuth: true,
  },
  {
    path: '/states',
    element: <State />,
    requiresAuth: true,
  },
  {
    path: '/districts',
    element: <District />,
    requiresAuth: true,
  },
  {
    path: '/institutions',
    element: <Institution />,
    requiresAuth: true,
  },
  {
    path: '/logs',
    element: <AdminLogs />,
    requiresAuth: true,
    requiresSuperAdmin: true,
  },
];

export default routes;
